import { Box, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTheme } from "@material-ui/core/styles";
import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import useFilterDropdownStyles from "../SharedStyles/useFilterDropdownStyles";

export function StatusFilter({ onFiltered }) {
  const [selecteds, setSelecteds] = useState([]);
  const theme = useTheme();
  const isDark = theme.mode === "dark" || theme.palette.type === "dark";
  const dropdownClasses = useFilterDropdownStyles();

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  const status = [
    { status: "open", name: `${i18n.t("tickets.search.filterConectionsOptions.open")}` },
    { status: "closed", name: `${i18n.t("tickets.search.filterConectionsOptions.closed")}` },
    { status: "pending", name: `${i18n.t("tickets.search.filterConectionsOptions.pending")}` },
    { status: "group", name: i18n.t("statusFilter.groups") },
  ];

  const summaryText =
    selecteds.length === 0
      ? ""
      : selecteds.length === 1
      ? selecteds[0].name
      : `${selecteds.length} ${i18n.t("statusFilter.selected") || "selecionados"}`;

  return (
    <Box style={{ padding: 10 }}>
      <Autocomplete
        multiple
        size="small"
        options={status}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(o) => o.name}
        getOptionSelected={(o, v) => o.status === v.status}
        disableCloseOnSelect
        renderTags={() => null}
        classes={{ paper: dropdownClasses.paper }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={selecteds.length ? "" : i18n.t("statusFilter.title")}
            InputProps={{
              ...params.InputProps,
              startAdornment: summaryText ? (
                <span style={{
                  marginLeft: 6,
                  marginRight: 6,
                  fontSize: 13,
                  fontWeight: 600,
                  color: isDark ? "#e9edef" : "#0f172a",
                }}>{summaryText}</span>
              ) : null,
            }}
          />
        )}
      />
    </Box>
  );
}
